import { render } from "./MyEVehicleDetail.vue?vue&type=template&id=ba37f98c&scoped=true"
import script from "./MyEVehicleDetail.vue?vue&type=script&lang=js"
export * from "./MyEVehicleDetail.vue?vue&type=script&lang=js"

import "./MyEVehicleDetail.vue?vue&type=style&index=0&id=ba37f98c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba37f98c"]])

export default __exports__